import { LinkClickImpression } from "@jmc/core/src/components/LinkClickImpression/index";
import { LinkButton } from "@jmc/solid-design-system/src/components/atoms/LinkButton/LinkButton";
import { Typography } from "@jmc/solid-design-system/src/components/atoms/Typography/Typography";
import useIsClient from "@jmc/utils/hooks/useIsClient";
import React from "react";
import { useTranslation } from "react-i18next";
import { UseSearchBoxProps } from "react-instantsearch";
import regexifyString from "regexify-string";

import style from "./style.module.scss";

interface PropTypes extends UseSearchBoxProps {
    showResetFilters?: boolean;
    clear?: () => void;
    refine?: (value: string) => void;
    query?: string;
}

export const NoAlgoliaSearchResults = (props: PropTypes): JSX.Element => {
    const { t } = useTranslation();
    const { refine, query, clear, showResetFilters = true } = props;
    const isClient = useIsClient();

    const resetSearchBox = (): void => {
        refine("");
        clear();
    };

    const input = t(`No results found for {{SEARCH_TERM}}`, { SEARCH_TERM: `[${query}]`, ns: "common" });
    const decorateSpan = (): JSX.Element | string => {
        if (isClient) {
            return (
                <>
                    <span className={style["search-term"]}>{`"${query}"`}</span>{" "}
                    <LinkClickImpression
                        name="Reset Search"
                        targetUrl={window?.location?.pathname}
                        placement="page:recipegrid"
                        external={false}
                    >
                        <LinkButton className={style["reset-algolia-query-link"]} onClick={resetSearchBox}>
                            {t("reset filters", { ns: "common" })}
                        </LinkButton>
                    </LinkClickImpression>{" "}
                    {t("and try again", { ns: "common" })}
                </>
            );
        } else {
            return null;
        }
    };

    let message = [];
    if (showResetFilters) {
        message = regexifyString({
            pattern: /\[.*?\]/gim,
            decorator: decorateSpan,
            input,
        });
    } else {
        message = [t("No results found.", { ns: "common" })];
    }

    return (
        <div className={style["algolia-no-results"]}>
            <button onClick={resetSearchBox} className={style.resetLink}>
                <Typography variant="body">{message?.map((item, index) => <span key={index}>{item}</span>)}</Typography>
            </button>
        </div>
    );
};

export default NoAlgoliaSearchResults;
